import { LegalPage, type LegalSection } from '@/components/legal/legal-page';

const sections: readonly LegalSection[] = [
  {
    title: 'Get help',
    body: [
      'Email ajay.koenig@gmail.com for sign-in problems, account questions, event registration issues, safety or abuse reports, privacy requests, and account deletion support.',
      'Include the email attached to your account, the event or screen involved, and a short description of what happened. Do not send passwords, one-time codes, payment credentials, or government identification.',
    ],
  },
  {
    title: 'Response and safety',
    body: [
      'We aim to review support requests promptly. For an immediate emergency during a run or event, contact local emergency services or an on-site run captain; this support address is not an emergency channel.',
    ],
  },
];

export default function SupportScreen() {
  return (
    <LegalPage
      actions={[
        {
          href: 'mailto:ajay.koenig@gmail.com?subject=6am%20app%20support',
          label: 'Email support',
        },
        { href: '/privacy', label: 'Privacy policy', variant: 'secondary' },
      ]}
      intro="Support for the 6am BKK app and run-club platform."
      sections={sections}
      title="Support"
      updatedAt="22 July 2026"
    />
  );
}
